/** A draft is worth a warning once it has content that no save has captured. */
export const isDraftUnsaved = (doc: string, savedDoc: string | null): boolean =>
  doc.trim() !== '' && doc !== savedDoc

/** Asks the browser to confirm before unload while the draft is unsaved. */
export const createUnloadGuard = (isDirty: () => boolean): (() => void) => {
  const onBeforeUnload = (event: BeforeUnloadEvent): void => {
    if (!isDirty()) return
    event.preventDefault()
  }
  window.addEventListener('beforeunload', onBeforeUnload)
  return () => window.removeEventListener('beforeunload', onBeforeUnload)
}
